import CopyModal from '@atlassian/jira-copy-filters-modal/src';
import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model';
import { connect } from '@atlassian/jira-react-redux';
import { closeCopyFilterModal } from '../../../state/actions/copy-filter-modal';
import { getBaseUrl } from '../../../state/selectors/app';
import { isFavourite } from '../../../state/selectors/filters';
import type { State } from '../../../state/types';

export default connect(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(state: State, ownProps: OperationModalProps<Record<any, any>>) => ({
		baseUrl: getBaseUrl(state),
		id: ownProps.entityId,
		isFavourite: isFavourite(state, ownProps.entityId),
		onCancel: ownProps.onCancel,
		onInitiateSuccess: () => {
			ownProps.onDialogShown();
		},
		onDataRetrieveFailed: () => {
			ownProps.onDataRetrieveFailed();
		},
		onCopied: () => {
			// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
			ownProps.onUpdated();
		},
	}),
	{
		onCloseCopyFilterModal: closeCopyFilterModal,
	},
)(CopyModal);
